import tabNames from './tabNames';

export const adminAccessibleTabs = [
   tabNames.details,
   tabNames.privacy,
   tabNames.analytics,
   tabNames.editMedia,
   tabNames.accessibility,
   tabNames.quizzing,
   tabNames.conversations,
   tabNames.conversation
];

export const adminAccessibleImageTabs = [
   tabNames.details,
   tabNames.privacy,
   tabNames.analytics,
   tabNames.conversations,
   tabNames.conversation
];

export const captionAccessibileTabs = [
   tabNames.details,
   tabNames.accessibility
];

export const viewerAccessibleTabs = [
   tabNames.details
];
